import { IAppState } from '../store';

export const selectHasVerifiedDocuments = (state: IAppState): boolean =>
  !!state.realtor.moderationInfo?.isUserIdentifiedByDocuments;
